import { openDB } from 'idb';

const DB_NAME = 'baserri_aditu_db';
const STORE_NAME = 'messages';
const SYNC_STORE = 'sync_queue';

export const initDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(SYNC_STORE)) {
        db.createObjectStore(SYNC_STORE, { keyPath: 'id', autoIncrement: true });
      }
    },
  });
};

export const saveMessage = async (message) => {
  const db = await initDB();
  return db.add(STORE_NAME, message);
};

export const getMessages = async () => {
  const db = await initDB();
  return db.getAll(STORE_NAME);
};

export const addToSyncQueue = async (payload) => {
  const db = await initDB();
  return db.add(SYNC_STORE, payload);
};

export const getSyncQueue = async () => {
  const db = await initDB();
  return db.getAll(SYNC_STORE);
};

export const clearSyncQueue = async () => {
  const db = await initDB();
  return db.clear(SYNC_STORE);
};
